import { styled, FormControlLabel as FormControlLabel$1 } from "@mui/material";
const DiseasesContainer = styled("div")({
  display: "flex",
  flexDirection: "column"
});
const ToggleContainer = styled("div")(({ theme, checked }) => ({
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.grey[800],
  borderRadius: "4px 4px 0px 0px",
  borderBottom: checked ? `0.5px solid ${theme.palette.grey[300]}` : "none"
}));
const FormControlLabel = styled(FormControlLabel$1)(({ error, theme }) => ({
  marginLeft: 0,
  justifyContent: "space-between",
  width: "100%",
  color: error ? theme.palette.error[500] : "currentColor"
}));
export {
  DiseasesContainer,
  FormControlLabel,
  ToggleContainer
};
